module.exports = __webpack_public_path__ + "static/img/image_font.a2444a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image_font.png
// module id = 886I
// module chunks = 1